import { Users, Briefcase, Cpu, Building2 } from "lucide-react";

const audiences = [
  {
    id: 1,
    icon: Users,
    title: "Engineers & CAD Professionals",
    description: "Mechanical, civil, and design engineers looking to enhance their automation skills"
  },
  {
    id: 2,
    icon: Briefcase,
    title: "Engineering Graduates",
    description: "Fresh graduates wanting to add automation expertise to their portfolio"
  },
  {
    id: 3,
    icon: Cpu,
    title: "Automation Enthusiasts",
    description: "Anyone passionate about streamlining design workflows through programming"
  },
  {
    id: 4,
    icon: Building2,
    title: "Organizations",
    description: "Companies looking to optimize CAD workflows and boost team productivity"
  }
];

const WhoShouldAttend = () => {
  return (
    <section 
      data-testid="who-should-attend-section"
      className="py-20 lg:py-28 bg-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 
            data-testid="who-should-attend-title"
            className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#0F172A]"
            style={{ fontFamily: "'Space Grotesk', sans-serif" }}
          >
            Who Should Attend?
          </h2>
          <p className="mt-4 text-lg text-[#0F172A]/60 max-w-2xl mx-auto">
            Our programs are designed for professionals at all stages of their careers
          </p>
        </div>

        {/* Audience Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {audiences.map((audience) => (
            <div
              key={audience.id}
              data-testid={`audience-card-${audience.id}`}
              className="text-center p-6 rounded-2xl bg-[#F8FAFC] border border-slate-100 hover:border-[#06B6D4]/30 transition-colors"
            >
              {/* Icon */}
              <div className="w-14 h-14 rounded-xl bg-[#06B6D4]/10 flex items-center justify-center mx-auto mb-4">
                <audience.icon className="w-7 h-7 text-[#06B6D4]" />
              </div>

              <h3 
                className="text-base font-semibold text-[#0F172A] mb-2"
                style={{ fontFamily: "'Space Grotesk', sans-serif" }}
              >
                {audience.title}
              </h3>
              <p className="text-[#0F172A]/60 text-sm leading-relaxed">
                {audience.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhoShouldAttend;
